module.exports = __webpack_public_path__ + "img/187w.10d0060.jpg";